/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-05, 14:29:03
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { API_URL } from '@/config';
import { mapActions } from 'vuex';

// CHILD COMPONENTS ////////////////////////////////////////////////////////////
import Card from '@/components/Common/Card';
import BillingDetailsTableForPostpaid from '@/components/Billing/BillingDetails/BillingDetailsTableForPostpaid';
import BillingDetailsTableForPrepaid from '@/components/Billing/BillingDetails/BillingDetailsTableForPrepaid';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'BillingDetails',

  components: { Card, BillingDetailsTableForPostpaid, BillingDetailsTableForPrepaid },

  props: ['billingList', 'billingListActualPage', 'isLoadingData', 'subscriber'],

  computed: {
    pagesCount() {
      return this.billingList.count ? Math.ceil(this.billingList.count / 25) : 1;
    },
    downloadBillingData() {
      let _phoneNumber = this.billingList.terms.phoneNumber || null;
      return `${API_URL}/billing/export?from=${this.billingList.terms.dateStart}&to=${this.billingList.terms.dateEnd}&sortby=${this.billingList.terms.sortBy}&sort=${this.billingList.terms.sort}&number=${_phoneNumber}`;
    },
  },

  methods: {
    ...mapActions(['setBillingTerms', 'getBillingList']),
    nextPage() {
      const nextPage = this.billingListActualPage + 1;
      this.setBillingTerms({ page: nextPage })
        .then(this.getBillingList);
    },
    previousPage() {
      const previousPage = this.billingListActualPage - 1;
      this.setBillingTerms({ page: previousPage })
        .then(this.getBillingList);
    },
    searchByNumber(phoneNumber) {
      this.setBillingTerms({ phoneNumber, page: 1 })
        .then(this.getBillingList);
    },
    clearNumber() {
      this.setBillingTerms({ phoneNumber: null, page: 1 })
        .then(this.getBillingList);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Billing/BillingDetails/component.js